import { render } from "./recentPage.vue?vue&type=template&id=81342d0a"
import script from "./recentPage.vue?vue&type=script&lang=js"
export * from "./recentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__